var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourriel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 19.2h-51.2c-2.646 0-4.8 2.154-4.8 4.8v28.8c0 2.646 2.154 4.8 4.8 4.8h51.2c2.646 0 4.8-2.154 4.8-4.8v-28.8c0-2.646-2.154-4.8-4.8-4.8zM56 22.4c0.096 0 0.186 0.010 0.278 0.026l-24.102 16.067c-0.928 0.618-2.621 0.618-3.549 0l-24.102-16.067c0.090-0.016 0.182-0.026 0.278-0.026h51.197zM56 54.4h-51.2c-0.883 0-1.6-0.717-1.6-1.6v-27.411l23.651 15.766c0.995 0.662 2.272 0.995 3.549 0.995s2.554-0.333 3.549-0.995l23.651-15.766v27.411c0 0.883-0.717 1.6-1.6 1.6z",
    fill: "#223654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourriel);
export default __webpack_public_path__ + "static/media/courriel.15f7e0dfba147413a34d13f4cc5b3eac.svg";
export { ForwardRef as ReactComponent };